import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import SuccessTransferModal from "./SuccessTransferModal";
import { useForm, Controller } from "react-hook-form";
import { Context } from "../../../../utils/context";
import classNames from "classnames";
import Select from "react-select";
import SuccessAssignModal from "./SuccessAssignModel";
const AssignEngineerModel = (props) => {
  const [assignLoading, setAssignLoading] = useState(false);

  const [modalTransfer, setModalTransfer] = useState(false);

  const { getData, postData, Select2Data } = useContext(Context);

  const [complaint_status, setcomplaint_status] = useState([]);
  const [service_engineer, setservice_engineer] = useState([]);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
  } = useForm();
  const [product, setProduct] = useState([]);

  const [productIDS, setProductIDS] = useState([]);

  const [productSelections, setProductSelections] = useState([]);

  useEffect(() => {
    reset({ ids: props?.ids });
  }, [props?.ids]);

  const [minScheduleDate, setMinScheduleDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const [scheduleDate, setScheduleDate] = useState("");

  const handleScheduleDateChange = (event) => {
    setScheduleDate(event.target?.value);
  };

  const GetAllProduct = async () => {
    const response = await getData("/masters/allproducts-list");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "product_id",
          label: data.name,
        });
      });
    }
    setProduct(option);
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  const selectedDate = watch("schedule_date");
  const today = new Date().toISOString().split("T")[0];

  const currentTime = new Date().toTimeString().slice(0, 5);

  const handleProductChange = (selectedOptions) => {
    const updatedProducts = selectedOptions
      ? selectedOptions.map((opt) => {
          const existing = productSelections.find(
            (p) => p.product_id === opt.value
          );

          return existing ? existing : { product_id: opt.value, quantity: 1 };
        })
      : [];

    setProductSelections(updatedProducts);
  };

  const handleQuantityChange = (productId, qty) => {
    const safeQty = Math.max(1, Number(qty));

    setProductSelections((prev) =>
      prev.map((p) =>
        p.product_id === productId ? { ...p, quantity: safeQty } : p
      )
    );
  };

  const onSubmit = async (data) => {
    try {
      setAssignLoading(true);

      const payload = {
        completion_time: data?.completion_time,
        product_id: productSelections,
        schedule_date: data?.schedule_date,
        schedule_time: data?.schedule_time,
        service_engineer_id: data?.service_engineer_id,
        ids: data?.ids,
      };

      const response = await postData(
        `/complaint-management/complaints/assign-engineer`,
        payload
      );

      if (response?.success) {
        setModalTransfer(true);
        reset();

        setTimeout(() => {
          setModalTransfer(false);
          props.onHide();
          props.getAllData();
        }, 1000);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAssignLoading(false);
    }
  };

  const getAllData = async () => {
    {
      const res = await getData(`/masters/all-complaint-status`);
      setcomplaint_status(await Select2Data(res?.data, "complaint_status_id"));
    }
    {
      const res = await getData(`/masters/all-service-engineers`);
      setservice_engineer(res?.data);
    }
  };

  useEffect(() => {
    getAllData();
    reset();
  }, [props.show]);

  return (
    <>
      <Modal
        {...props}
        // size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="main-class-modal">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h6 className="mt-2">Assign Engineer</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Form.Group className="mb-3">
                <Form.Label>Assign to</Form.Label>

                <Controller
                  name="service_engineer_id"
                  control={control}
                  rules={{ required: "Service engineer is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={service_engineer}
                      isDisabled={props.view}
                      placeholder="Select Engineer"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.service_engineer_id
                            ? "red"
                            : base.borderColor,
                        }),
                      }}
                    />
                  )}
                />

                {errors.service_engineer_id && (
                  <small className="text-danger">
                    {errors.service_engineer_id.message}
                  </small>
                )}
              </Form.Group>

              <Col xs={6}>
                <Form.Group>
                  <Form.Label>Schedule Date</Form.Label>
                  <Form.Control
                    type="date"
                    min={today}
                    {...register("schedule_date", {
                      required: "Schedule date is required",
                    })}
                    isInvalid={!!errors.schedule_date}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.schedule_date?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col xs={6}>
                <Form.Group>
                  <Form.Label>Schedule Time</Form.Label>
                  <Form.Control
                    type="time"
                    min={selectedDate === today ? currentTime : undefined}
                    {...register("schedule_time", {
                      required: "Schedule time is required",
                      validate: (value) => {
                        if (selectedDate === today && value < currentTime) {
                          return "Past time is not allowed for today";
                        }
                        return true;
                      },
                    })}
                    isInvalid={!!errors.schedule_time}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.schedule_time?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col xs={6}>
                <Form.Group>
                  <Form.Label>Completion Date</Form.Label>
                  <Form.Control
                    type="date"
                    min={minScheduleDate}
                    {...register("completion_time", {
                      required: "Completion date is required",
                    })}
                    isInvalid={!!errors.completion_time}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.completion_time?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Row>
                <Col xs={6}>
                  <Form.Label>Select Product</Form.Label>

                  <Select
                    isMulti
                    options={product}
                    value={product.filter((p) =>
                      productSelections?.some((ps) => ps.product_id === p.value)
                    )}
                    onChange={(selected) => {
                      handleProductChange(selected);
                    }}
                    className={errors.product ? "is-invalid" : ""}
                  />

                  {errors.product && (
                    <small className="text-danger">{errors.product}</small>
                  )}
                </Col>

                {productSelections?.map((item) => {
                  const productName = product.find(
                    (p) => p.value === item.product_id
                  )?.label;

                  return (
                    <div
                      key={item.product_id}
                      className="d-flex align-items-center mt-2">
                      <span className="me-2" style={{ minWidth: "120px" }}>
                        {productName}
                      </span>

                      <input
                        type="number"
                        min="1"
                        step="1"
                        className="form-control"
                        style={{ width: "100px" }}
                        value={item.quantity}
                        onChange={(e) => {
                          const value = Math.max(
                            1,
                            Number(e.target.value || 1)
                          );
                          handleQuantityChange(item.product_id, value);
                        }}
                        onBlur={(e) => {
                          if (!e.target.value || Number(e.target.value) < 1) {
                            handleQuantityChange(item.product_id, 1);
                          }
                        }}
                      />
                    </div>
                  );
                })}
              </Row>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="dark"
            type="button"
            disabled={assignLoading}
            onClick={handleSubmit(onSubmit)}>
            {assignLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Assigning...
              </>
            ) : (
              "Assign"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <SuccessAssignModal
        show={modalTransfer}
        onHide={() => setModalTransfer(false)}
      />
    </>
  );
};

export default AssignEngineerModel;
